// Click-to-play video tiles (Dlaczego West Coast Swing). Each tile is a
// button carrying data-video-id; the first click swaps it for a
// youtube-nocookie iframe, so no player — and no YouTube cookies — loads
// until a visitor asks for the video.
export function initVideoTiles() {
  document.addEventListener("click", (event) => {
    const button = event.target.closest(".cms-video-tile__poster[data-video-id]");
    if (!button) return;
    const id = button.dataset.videoId;
    if (!id) return;

    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
    iframe.title = button.dataset.videoTitle || "";
    iframe.allow = "autoplay; encrypted-media; picture-in-picture";
    iframe.allowFullscreen = true;
    // YouTube refuses to play without a Referer (player error 153).
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    button.replaceWith(iframe);
  });
}
